module.exports = __webpack_public_path__ + "img/icon-skill-input.383dfe40.svg";